import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import headerDecor from "@/assets/icons/header-decor.png";
import authBanner from "@/assets/auth-banner.png";
import handsEmoji from "@/assets/icons/hands-emoji.png";
import apnaSanatan from "@/assets/apna-sanatan.svg";
import Button from "@/components/Button";
import Input from "@/components/Input";

export default function AuthPage() {
  const navigate = useNavigate();

  // const handleNewAstrologer = async (e) => {
  //   e.preventDefault();
  //   navigate("/auth/registration", {
  //     replace: true,
  //     viewTransition: true,
  //   });
  // };

  const handleNavigate = async (e) => {
    e.preventDefault();
    navigate("/auth/login", {
      replace: true,
      viewTransition: true,
    });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-white p-4">
      <div className="md:w-full bg-white rounded-2xl  flex flex-col-reverse md:flex-row items-center">
        {/* Left Side Image */}
        <div className="md:w-1/2 relative p-4 hidden md:block">
          <img
            src={authBanner}
            alt="Sanatan Ka Ghar"
            className="aspect-[1.1] w-full object-cover rounded-2xl"
          />
        </div>

        {/* Right Side Form */}
        <div className="md:w-1/2  max-w-md flex flex-col justify-center items-center md:ml-auto md:mr-auto">
          <img src={apnaSanatan} alt="Apna Sanatan" className="h-32 mb-4" />
          <h2 className="  text-3xl md:text-4xl font-semibold font-primary flex items-center">
            Welcome
            <img
              src={handsEmoji}
              alt="🙏🏻"
              className=" h-8 ml-2 mb-2 object-cover "
            />
          </h2>
          <p className=" text-2xl md:text-3xl lg:text-4xl font-semibold font-primary flex items-center mb-2">
            Apna Sanatan
            <span className="text-primary ">&nbsp; Astrologer!</span>
          </p>
          <div className="flex flex-row items-center justify-center gap-2 ">
            <img src={headerDecor} alt="" className="w-12 h-2" />
            <p className="text-lg text-gray-500    text-center  ">
              We make you work easier
            </p>
            <img src={headerDecor} alt="" className="w-12 h-2  scale-x-[-1]" />
          </div>
          <hr className="bg-primary h-[2px] opacity-30   w-full my-4" />
          <div className="gap-4 w-full flex flex-col">
            {/* <Button
              type="submit"
              title="Are you new astrologer"
              variant="primary"
              onClick={handleNewAstrologer}
            /> */}
            <Button
              type="submit"
              title="Login"
              variant="secondary"
              onClick={handleNavigate}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
